import {
  GET_LOADER_STATUS,
  SET_LOADER_STATUS,
} from "../constants/loader-constants";

const initialState = {
  status: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADER_STATUS:
      const { status } = action;
      return { ...state, status };
    default:
      return state;
  }
};
